export const useComposable = () => {
    //* 插件
    const i18n = useI18n();

    //* 静态变量
    const vars = {
        steps: [
            {
                step: i18n.t("Step1"),
                contents: [i18n.t("MutationStep1"), i18n.t("MutationStep1example1"), i18n.t("MutationStep1example2"), i18n.t("MutationStep1example3")],
                image:
                    i18n.locale.value === "en"
                        ? "https://rdgta.cdn.cyagen.com/rddc/pictures/a3f4cb42-3d6f-43ff-ae1a-ba98dabcf02f.webp"
                        : "https://rdgta.cdn.cyagen.com/rddc/pictures/d0b808fb-ab98-49ce-8462-1fa10cfbafce.webp",
            },
            {
                step: i18n.t("Step2"),
                contents: [i18n.t("MutationStep2")],
                image:
                    i18n.locale.value === "en"
                        ? "https://rdgta.cdn.cyagen.com/rddc/pictures/4f22a4a2-e40d-41f9-bf21-883d3fcaf8f7.webp"
                        : "https://rdgta.cdn.cyagen.com/rddc/pictures/0c6c7c45-6268-45d3-a082-e5dc5dc4496e.webp",
            },
            {
                step: i18n.t("Step3"),
                contents: [i18n.t("MutationStep3")],
                image:
                    i18n.locale.value === "en"
                        ? "https://rdgta.cdn.cyagen.com/rddc/pictures/d67db49f-bd0a-49e7-ac38-267e2b150eb1.webp"
                        : "https://rdgta.cdn.cyagen.com/rddc/pictures/6173d1d2-f893-43ec-a46f-608a59ec49f1.webp",
            },
            {
                step: i18n.t("Step4"),
                contents: [i18n.t("MutationStep4")],
                image:
                    i18n.locale.value === "en"
                        ? "https://rdgta.cdn.cyagen.com/rddc/pictures/4e5b286c-7351-408a-be6a-c1c51e311435.webp"
                        : "https://rdgta.cdn.cyagen.com/rddc/pictures/8940222a-b098-4165-b1df-93c7d84040e6.webp",
            },
        ],
    };

    //* 响应式变量
    const refs = {
        show: ref<boolean>(false),
        step: ref<number>(1),
        styles: ref<any>({}),
    };

    //* 函数列表
    const methods = {
        open: () => {
            refs.show.value = true;
            refs.step.value = 1;
            window.scrollTo({ top: 0 });
            document.body.style.overflow = "hidden";
        },

        close: () => {
            refs.show.value = false;
            document.body.style.overflow = "";
        },
    };

    return { refs, vars, methods };
};
